import React from 'react';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import { useGetManyExpenses } from 'api/expenses/use-get-many-expenses';
import type { IExpensesFilter } from 'shared/stores/use-expenses-filters';
import { formatDate } from 'shared/utils/time/format-date';
import { ExpenseStatus } from 'types/expense-status';
import { ExpensesList } from 'components/expenses/expenses-list';
import type { IFutureExpensePointModalProps } from './types';

export const FutureExpensePointModal: React.FC<IFutureExpensePointModalProps> = (props) => {
  const { isOpen, onClose, point } = props;

  const selectedDay = dayjs(point.x);

  const filters: IExpensesFilter = {
    endDate: [selectedDay, selectedDay],
    statuses: [ExpenseStatus.Waiting, ExpenseStatus.Problem],
  };

  const { data, isFetching } = useGetManyExpenses({
    filters,
    isSkip: !isOpen,
  });

  const title = `Expenses — ${formatDate(selectedDay)}`;

  return (
    <Modal title={title} open={isOpen} footer={null} width={900} onCancel={onClose}>
      <ExpensesList expenses={data?.data ?? []} isLoading={isFetching} />
    </Modal>
  );
};
